module.exports = __webpack_public_path__ + "static/media/ibd_foot1.0b657258.png";